var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-divider',{staticStyle:{"margin-top":"7px","margin-bottom":"8px"}})}
var staticRenderFns = []

export { render, staticRenderFns }